var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "client_complete" } },
    [
      _c("dd-header"),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "div",
          { staticClass: "main_content" },
          [
            _c("dd-menu", { ref: "menuRef" }),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { id: "payment_service" } },
              [
                _c("dd-sitemap", {
                  attrs: {
                    pageKey: _vm.pageKey,
                    pageList: _vm.pageList,
                    mapStyle: "topic_path"
                  }
                }),
                _vm._v(" "),
                _c("section", { attrs: { id: "president_msg" } }, [
                  _c("h2", [_vm._v("事業者様向け「後払い」サービスのご案内")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n            SEIKYU＋は事業者様向けの後払いサービスです。\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "payment_guide_img2" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "https://bizforward.co.jp/seikyuplus/buyer/top",
                          target: "_blank"
                        }
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage("top/payment/seikyuplus_01.jpg")
                          }
                        })
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "payment_guide_img" }, [
                    _c("img", {
                      attrs: {
                        src: _vm.getImage("top/payment/seikyuplus_02.jpg")
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("section", [
                  _c(
                    "div",
                    {
                      class: {
                        detail_btn8: true,
                        btn_pos_center: true,
                        disabled: !_vm.isCorpLogin
                      },
                      on: { click: _vm.confirm }
                    },
                    [_vm._v("お申込みはこちら")]
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "right" }, [
                    _vm._v(
                      "※株式会社Biz Forwardの審査によりご希望に添えない場合もございますので予めご了承ください。"
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("div", [_vm._v("お問い合わせ")]),
                  _vm._v(" "),
                  _c("div", [
                    _c("a", { attrs: { href: "tel:0362761123" } }, [
                      _c("img", {
                        attrs: { src: _vm.getImage("bunner/TEL.webp") }
                      })
                    ])
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("お支払いサイクルについて")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "納品日の当月末日締めにてご請求書を発行、お支払い期限は翌月末日となります。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", [
      _c("div", [_vm._v("お申し込みからサービス開始までの流れ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            お申し込み受付後、株式会社Biz Forwardにて審査が行われます。"
        ),
        _c("br"),
        _vm._v(
          "\n            審査及び利用開始のお手続きについて、審査にお日にちがかかる場合がございます"
        ),
        _c("br"),
        _vm._v(
          "\n            審査通過のご連絡をもって後払いサービスをご利用いただけます。"
        ),
        _c("br"),
        _vm._v(
          "\n            請求書は株式会社Biz Forwardから発行され、メールにて送付させていただきます。"
        ),
        _c("br"),
        _vm._v(
          "\n            銀行振込手数料は、貴社ご負担となります。\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-659a082b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659a082b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcPaymentService.vue
// module id = null
// module chunks = 